export const TITLE_MAX_LENGTH = 60
export const OG_TITLE_MAX_LENGTH = TITLE_MAX_LENGTH
export const OG_DESCRIPTION_MAX_LENGTH = 150
